var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hashtagString)?_c('div',{staticClass:"hashtags"},[_c('marquee-text',{attrs:{"duration":_vm.speed,"repeat":5}},[_vm._v(" "+_vm._s(_vm.hashtagString)+" //\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }